import Icon from '../components/Icon';

const Weather2Colored = Icon(
  'weather-2-colored',
  <>
    <path
      fill="#4C8BF9"
      fillRule="evenodd"
      d="M4.878 9.506c1.2-5.068 6.758-8.876 12.068-7.035a.488.488 0 0 1 .05.903c-.766.365-1.52.926-2.21 1.628 4.908 1.328 8.553 6.727 6.742 11.91a.484.484 0 0 1-.894.05c-.358-.745-.906-1.48-1.592-2.154-1.349 4.906-6.786 8.524-11.988 6.721a.488.488 0 0 1-.05-.903c.911-.434 1.778-.944 2.534-1.547C4.466 17.906.621 12.384 2.472 7.09a.485.485 0 0 1 .894-.051c.426.885.924 1.729 1.512 2.468m4.507 2.51a2.64 2.64 0 0 1 2.63-2.65 2.64 2.64 0 0 1 2.63 2.65 2.64 2.64 0 0 1-2.63 2.65 2.64 2.64 0 0 1-2.63-2.65"
      clipRule="evenodd"
    />
  </>
);

export default Weather2Colored;
